export enum FormaPagamentoEnum {
  PIX = "PIX",
  BOLETO = "BOLETO",
  CARTAO = "CARTAO",
  TODOS = "TODOS",
  DEPOSITO = "DEPOSITO",
}
